import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import styles from './index.module.scss';
import spin_icon from '../../../../../../imgs/spin_icon.png';
import cost_icon from '../../../../../../imgs/cost_icon.png';
import budget_icon from '../../../../../../imgs/budget@2x.png';
import usage_electricity_icon from '../../../../../../imgs/usage_electricity_icon.png';
import usage_water_icon from '../../../../../../imgs/usage_water_icon.png';
import usage_gas_icon from '../../../../../../imgs/usage_gas_icon.png';

import { formatThousandAndUnit, keepOnePercentOrLine } from '@/utils/utils';
import { Progress, Spin } from 'antd';
import dayjs from 'dayjs';

const EnergyUsageCost = () => {
  const {
    energyCostData,
    dateValue,
    energyCostDataLoading: loading,
  } = useContext(ShareDataUnityEnergyCockpitMapContext);

  const formatRightData = useMemo(() => {
    return [
      {
        label: '用电成本',
        icon: usage_electricity_icon,
        value: energyCostData?.electricCharges,
        rate: energyCostData?.electricPercentage,
      },
      {
        label: '用水成本',
        icon: usage_water_icon,
        value: energyCostData?.waterCharges,
        rate: energyCostData?.waterPercentage,
      },
      {
        label: '用气成本',
        icon: usage_gas_icon,
        value: energyCostData?.gasCharges,
        rate: energyCostData?.gasPercentage,
      },
    ];
  }, [energyCostData]);

  return (
    <Spin spinning={loading}>
      <div className={styles.cost_wrapper}>
        <div className={styles.left_card}>
          <div className={styles.cost_info}>
            <div className={styles.icon}>
              <img src={spin_icon} className={styles.icon_spin} alt="" />
              <img src={budget_icon} className={styles.icon_icon} alt="" />
            </div>
            <div className={styles.label_value}>
              <div className={styles.label}>计划成本(元)</div>
              <div className={styles.value}>
                {formatThousandAndUnit(energyCostData?.planCharges).value}
                <span className={styles.unit_label}>{formatThousandAndUnit(energyCostData?.planCharges).unit}</span>
              </div>
            </div>
          </div>
          <div className={`${styles.cost_info} ${styles.cost_info2}`}>
            <div className={styles.icon}>
              <img src={spin_icon} className={styles.icon_spin} alt="" />
              <img src={cost_icon} className={styles.icon_icon} alt="" />
            </div>
            <div className={styles.label_value}>
              <div className={styles.label}>实际成本(元)</div>
              <div className={styles.value}>
                {formatThousandAndUnit(energyCostData?.charges).value}
                <span className={styles.unit_label}>{formatThousandAndUnit(energyCostData?.charges).unit}</span>
              </div>
            </div>
          </div>
          <div className={styles.cost_portion}>
            <div className={styles.label}>占比：</div>
            <div style={{ width: 40, marginTop: -2 }}>
              <Progress
                percent={((energyCostData?.charges ?? 0) / (energyCostData?.planCharges ?? 0)) * 100}
                showInfo={false}
                size="small"
                strokeColor={'#16DD8E'}
              />
            </div>
            <span>{keepOnePercentOrLine(energyCostData?.proportion as unknown as number)}%</span>
          </div>
        </div>
        <div className={styles.right_card}>
          {formatRightData.map(item => (
            <div className={styles.item_card} key={item.label}>
              <div className={styles.item_left_img}>
                <img className={styles.img_sty} src={item.icon} alt="" />
              </div>
              <div className={styles.item_right_content}>
                <div className={styles.top_wrapper}>
                  <div className={styles.label}>{item.label}(元)</div>
                  <div className={styles.process}>
                    <Progress
                      percent={item.rate ? (item.rate ?? 0) * 100 : undefined}
                      showInfo={false}
                      size="small"
                      strokeColor={'#16DD8E'}
                    />
                  </div>
                </div>
                <div className={styles.bottom_wrapper}>
                  <div className={styles.value}>
                    {formatThousandAndUnit(item?.value).value}
                    <span className={styles.unit}>{formatThousandAndUnit(item.value).unit}</span>
                  </div>
                  <div className={styles.rate}>{keepOnePercentOrLine(item?.rate)}%</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Spin>
  );
};

export default EnergyUsageCost;
